import { COLOR } from '@src/styles/color';

export const variantMapping = {
  contained: {
    backgroundColor: COLOR.yellow.default,
    color: COLOR.darkBlue,
    padding: '12px 24px',
    borderRadius: '12px',
    boxSizing: 'border-box',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      backgroundColor: COLOR.yellow.default,
      pointerEvents: 'auto',
    },
  },
  containedDelete: {
    backgroundColor: COLOR.redPrimary,
    color: COLOR.white,
    padding: '12px 24px',
    borderRadius: '12px',
    boxSizing: 'border-box',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      backgroundColor: COLOR.redPrimary,
      pointerEvents: 'auto',
    },
    '&:hover': {
      backgroundColor: COLOR.redPrimary,
      opacity: 0.8,
    },
  },
  outlined: {
    backgroundColor: COLOR.white,
    color: COLOR.darkBlue,
    border: `1px solid ${COLOR.borderButtonCorlor}`,
    padding: '12px 24px',
    borderRadius: '12px',
    boxSizing: 'border-box',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      pointerEvents: 'auto',
      '&:hover': {
        backgroundColor: COLOR.white,
        border: `1px solid ${COLOR.borderButtonDisabled}`,
        boxShadow: 'none',
      },
    },
  },
  outlineSmall: {
    backgroundColor: COLOR.white,
    color: COLOR.darkBlue,
    border: `1px solid ${COLOR.borderButtonCorlor}`,
    padding: '8px 12px',
    borderRadius: '12px',
    boxSizing: 'border-box',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      pointerEvents: 'auto',
      '&:hover': {
        backgroundColor: COLOR.white,
        border: `1px solid ${COLOR.borderButtonDisabled}`,
        boxShadow: 'none',
      },
    },
  },
  containedSmall: {
    backgroundColor: COLOR.yellow.default,
    color: COLOR.darkBlue,
    padding: '8px 12px',
    borderRadius: '12px',
    boxSizing: 'border-box',
    border: `1px solid ${COLOR.darkV2[16]}`,
    textTransform: 'none',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      backgroundColor: COLOR.yellow.default,
      pointerEvents: 'auto',
    },
  },
  containedSmallNonBorder: {
    backgroundColor: COLOR.yellow.default,
    color: COLOR.darkBlue,
    padding: '8px 12px',
    borderRadius: '12px',
    boxSizing: 'border-box',
    border: 'none',
    textTransform: 'none',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      backgroundColor: COLOR.yellow.default,
      pointerEvents: 'auto',
    },
  },
  outlineDelete: {
    color: COLOR.darkBlue,
    padding: '12px',
    borderRadius: '12px',
    boxSizing: 'border-box',
    backgroundColor: COLOR.backgroundRecordTime,
    transition: '0.4s',
    '&:hover': {
      backgroundColor: COLOR.backgroundRecordTimeHover,
    },
  },
  info: {
    backgroundColor: COLOR.infoNoiseReduction,
    color: COLOR.blueV2,
    padding: '12px 16px',
    borderRadius: '8px',
    boxSizing: 'border-box',
    '&:hover': {
      backgroundColor: COLOR.infoNoiseReduction,
      opacity: 0.8,
    },
  },
  transparent: {
    backgroundColor: 'transparent',
    color: COLOR.darkBlue,
    border: 'none',
    padding: '12px 24px',
    borderRadius: '12px',
    boxSizing: 'border-box',
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      pointerEvents: 'auto',
      '&:hover': {
        backgroundColor: COLOR.white,
        border: `1px solid ${COLOR.borderButtonDisabled}`,
        boxShadow: 'none',
      },
    },
  },
};
